document.addEventListener('DOMContentLoaded', () => {
  // Disclosure toggles
  document.querySelectorAll('[data-disclosure-toggle]').forEach(t => {
    t.addEventListener('click', () => {
      const target = document.getElementById(t.getAttribute('aria-controls'));
      const expanded = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', String(!expanded));
      if (target) target.classList.toggle('hide');
    });
  });
  // Smooth anchors
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });

  let cartDrawerApi = null;
  let cartDrawerInitialized = false;

  const initializeCartDrawer = () => {
    if (cartDrawerInitialized) return cartDrawerApi;
    cartDrawerInitialized = true;

    const drawerShell = document.querySelector('[data-nv-cart-drawer]');
    if (!drawerShell) return cartDrawerApi;

  const drawer = drawerShell.querySelector('.nv-cart-drawer');
  const cartItems = drawerShell.querySelector('[data-nv-cart-items]');
  const cartBody = drawerShell.querySelector('[data-nv-cart-body]');
  const cartFooter = drawerShell.querySelector('[data-nv-cart-footer]');
  const cartCountEls = drawerShell.querySelectorAll('[data-nv-cart-count]');
  const cartSubtotalEls = drawerShell.querySelectorAll('[data-nv-cart-subtotal], [data-nv-cart-checkout-total]');
  const cartCompareTotalEls = drawerShell.querySelectorAll('[data-nv-cart-compare-total]');
  const cartDiscounts = drawerShell.querySelector('[data-nv-cart-discounts]');
  const shippingBlock = drawerShell.querySelector('[data-nv-cart-shipping]');
  const shippingText = drawerShell.querySelector('[data-nv-cart-shipping-text]');
  const shippingProgress = drawerShell.querySelector('[data-nv-cart-shipping-progress]');
  const openTriggers = document.querySelectorAll('[data-nv-cart-drawer-open]');
  const closeTriggers = drawerShell.querySelectorAll('[data-nv-cart-drawer-close]');
  const freeShippingThreshold = Number(drawerShell.getAttribute('data-free-shipping-threshold')) || 0;
  const currencyCode = drawerShell.getAttribute('data-currency-code') || 'USD';
  const cartUrl = drawerShell.getAttribute('data-cart-url') || '/cart';
  const cartAddUrl = drawerShell.getAttribute('data-cart-add-url') || '/cart/add.js';
  const cartChangeUrl = drawerShell.getAttribute('data-cart-change-url') || '/cart/change.js';
  const cartJsonUrl = drawerShell.getAttribute('data-cart-json-url') || '/cart.js';
  const productRecommendationsUrl = drawerShell.getAttribute('data-product-recommendations-url') || '/recommendations/products.json';
  const upsellTrack = drawerShell.querySelector('[data-nv-cart-upsell-track]');
  const upsellCarousel = drawerShell.querySelector('[data-nv-cart-upsell-carousel]');
  const couponDisclosure = drawerShell.querySelector('.nv-cart-drawer__coupon-disclosure');
  const couponOpenButton = drawerShell.querySelector('[data-nv-cart-coupon-open]');
  const couponSheet = drawerShell.querySelector('[data-nv-cart-coupon-sheet]');
  let lastFocusedElement = null;
  let lastCouponFocusedElement = null;
  let cartRequest = Promise.resolve();
  let lastRecommendationsProductId = null;
  let upsellAutoTimer = null;
  let upsellResumeTimer = null;

  const formatMoney = (cents) => {
    const amount = (Number(cents) || 0) / 100;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, drawerShell.getAttribute('data-money-format') || undefined);
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[character]));

  const updateHeaderBadges = (count) => {
    document.querySelectorAll('[data-nv-cart-badge]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });

    document.querySelectorAll('[data-nv-cart-drawer-open]').forEach((trigger) => {
      const existingBadge = trigger.querySelector('[data-nv-cart-badge]');
      if (existingBadge || count === 0) return;

      const badge = document.createElement('span');
      badge.setAttribute('data-nv-cart-badge', '');
      badge.setAttribute('aria-hidden', 'true');
      badge.className = trigger.classList.contains('custom-header__bottom-nav-item')
        ? 'custom-header__bottom-nav-badge'
        : 'custom-header__cart-count';
      badge.textContent = count;
      trigger.appendChild(badge);
    });
  };

  const renderDiscounts = (cart) => {
    if (!cartDiscounts) return;
    const discountsByTitle = new Map();

    const addDiscount = (title, amount) => {
      const normalizedTitle = String(title || 'Discounts').trim() || 'Discounts';
      const key = normalizedTitle.toLowerCase();
      const current = discountsByTitle.get(key) || { title: normalizedTitle, amount: 0 };
      current.amount += Number(amount) || 0;
      discountsByTitle.set(key, current);
    };

    (cart.cart_level_discount_applications || []).forEach((discount) => {
      addDiscount(discount.title, discount.total_allocated_amount);
    });

    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((discount) => {
        const title = discount.discount_application && discount.discount_application.title
          ? discount.discount_application.title
          : 'Discounts';
        addDiscount(title, discount.amount);
      });
    });

    const rows = Array.from(discountsByTitle.values()).filter((row) => row.amount > 0);

    if (!rows.length && cart.total_discount > 0) {
      rows.push({ title: 'Discounts', amount: cart.total_discount });
    }

    cartDiscounts.innerHTML = rows.map((row) => `
      <div class="nv-cart-drawer__discount-row">
        <span><small>Discounts</small>${escapeHtml(row.title)}</span>
        <strong>-${formatMoney(row.amount)}</strong>
      </div>
    `).join('');
  };

  const updateFreeShipping = (cart) => {
    if (!shippingBlock || !shippingText || !shippingProgress || freeShippingThreshold <= 0) return;

    const total = Number(cart.total_price) || 0;
    const remaining = Math.max(0, freeShippingThreshold - total);
    const progress = Math.min(100, Math.round((total / freeShippingThreshold) * 100));

    shippingText.textContent = remaining > 0
      ? `You're ${formatMoney(remaining)} away from free shipping.`
      : 'Your order qualifies for free shipping.';
    shippingProgress.style.width = progress + '%';
  };

  const getCartCompareTotal = (cart) => (cart.items || []).reduce((sum, item) => {
    const quantity = Number(item.quantity) || 1;
    const compareLinePrice = Math.max(
      Number(item.original_line_price || 0),
      Number(item.original_price || item.price || 0) * quantity,
      Number(item.compare_at_price || item.variant_compare_at_price || 0) * quantity
    );
    return sum + compareLinePrice;
  }, 0);

  const renderCartItem = (item, index) => {
    const line = index + 1;
    const title = escapeHtml(item.product_title || item.title);
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="nv-cart-drawer__variant">${escapeHtml(item.variant_title)}</p>`
      : '';
    const sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? `<p class="nv-cart-drawer__variant nv-cart-drawer__variant--selling-plan"><span class="nv-cart-drawer__variant-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M20.25 13.1 12.1 21.25a2.5 2.5 0 0 1-3.54 0L2.75 15.44a2.5 2.5 0 0 1 0-3.54l8.15-8.15a2.5 2.5 0 0 1 1.77-.73h5.08a3.25 3.25 0 0 1 3.25 3.25v5.08a2.5 2.5 0 0 1-.73 1.75Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="16.25" cy="7.75" r="1.35" fill="currentColor"/></svg></span><span>${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</span></p>`
      : '';
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="${title}" class="nv-cart-drawer__image" loading="lazy">`
      : `<div class="nv-cart-drawer__image nv-cart-drawer__image--placeholder"></div>`;
    const linePrice = Number(item.final_line_price || item.line_price || 0);
    const compareLinePrice = Math.max(
      Number(item.original_line_price || 0),
      Number(item.original_price || item.price || 0) * Number(item.quantity || 1),
      Number(item.compare_at_price || item.variant_compare_at_price || 0) * Number(item.quantity || 1)
    );
    const compareMarkup = compareLinePrice > linePrice
      ? `<span class="nv-cart-drawer__compare">${formatMoney(compareLinePrice)}</span>`
      : '';

    return `
      <article class="nv-cart-drawer__item" data-cart-line="${line}" data-cart-key="${escapeHtml(item.key)}">
        <a href="${escapeHtml(item.url)}" class="nv-cart-drawer__media" aria-label="${title}">${image}</a>
        <div class="nv-cart-drawer__content">
          <div class="nv-cart-drawer__line-top">
            <div class="nv-cart-drawer__text">
              <a class="nv-cart-drawer__title" href="${escapeHtml(item.url)}">${title}</a>
              ${variantTitle}
              ${sellingPlan}
              <div class="nv-cart-drawer__price-row">
                <span class="nv-cart-drawer__price-values">${compareMarkup}<strong>${formatMoney(linePrice)}</strong></span>
                <div class="nv-cart-drawer__qty" data-cart-stepper>
                  <button type="button" data-cart-qty-change="-1" data-line="${line}" aria-label="Decrease quantity for ${title}"><span aria-hidden="true">-</span></button>
                  <input class="cart-qty-input" value="${item.quantity}" type="number" min="0" inputmode="numeric" data-cart-qty-input data-line="${line}" aria-label="Quantity for ${title}">
                  <button type="button" data-cart-qty-change="1" data-line="${line}" aria-label="Increase quantity for ${title}"><span aria-hidden="true">+</span></button>
                </div>
              </div>
            </div>
            <div class="nv-cart-drawer__item-actions">
              <button type="button" class="nv-cart-drawer__remove" data-cart-remove data-line="${line}" aria-label="Remove ${title}">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6.75V5.5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1.25m-8.25 0h10.5m-9.5 0 .62 11.25c.04.83.73 1.5 1.56 1.5h4.14c.83 0 1.52-.67 1.56-1.5l.62-11.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.45"/></svg>
              </button>
            </div>
          </div>
        </div>
      </article>
    `;
  };

  const normalizeProductUrl = (product) => {
    if (product.url) return product.url;
    if (product.handle) return `/products/${product.handle}`;
    return '#';
  };

  const getProductVariant = (product) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find((variant) => variant.available) || variants[0] || product;
  };

  const getProductMetafieldValue = (product, namespace, key) => {
    const metafields = product.metafields;
    if (!metafields) return '';
    if (Array.isArray(metafields)) {
      const metafield = metafields.find((entry) => entry && entry.namespace === namespace && entry.key === key);
      return metafield?.value ?? metafield ?? '';
    }
    const scoped = metafields[namespace]?.[key] ?? metafields[`${namespace}.${key}`];
    return scoped?.value ?? scoped ?? '';
  };

  const normalizeReviewCountLabel = (value) => {
    const text = String(value || '').trim();
    if (!text) return '';
    const lower = text.toLowerCase();
    if (lower.includes('review')) return text;
    if (lower.includes('rating')) {
      return text
        .replace(/ratings/g, 'reviews')
        .replace(/rating/g, 'review')
        .replace(/Ratings/g, 'Reviews')
        .replace(/Rating/g, 'Review');
    }
    const numeric = Number(lower.replace(/reviews?|ratings?|verified|amazon|[,+]/g, '').trim());
    return `${text} ${numeric === 1 ? 'review' : 'reviews'}`;
  };

  const renderRatingSummary = (product, wrapperClass) => {
    const ratingRaw = getProductMetafieldValue(product, 'custom', 'rating');
    const countRaw = getProductMetafieldValue(product, 'custom', 'review_count');
    const ratingValue = Number(typeof ratingRaw === 'object' ? ratingRaw.rating : ratingRaw);
    const countText = String(countRaw || '').trim();
    const countNumber = Number(countText.toLowerCase().replace(/reviews?|ratings?|verified|amazon|[,+]/g, '').trim());
    if (!ratingValue || ratingValue < 1 || ratingValue > 5 || !countNumber || countNumber <= 0) return '';

    const label = normalizeReviewCountLabel(countText);
    const stars = Array.from({ length: 5 }, (_, index) => {
      const fill = Math.max(0, Math.min(100, (ratingValue - index) * 100));
      return `<span class="nv-rating-summary__star" style="--nv-star-fill: ${fill}%;">&#9733;</span>`;
    }).join('');
    return `
      <div class="${wrapperClass} nv-rating-summary" role="img" aria-label="${escapeHtml(ratingValue)} out of 5 stars from ${escapeHtml(label)}">
        <span class="nv-rating-summary__stars" aria-hidden="true">
          ${stars}
        </span>
        <span class="nv-rating-summary__count">${escapeHtml(label)}</span>
      </div>
    `;
  };

  const renderUpsellCard = (product) => {
    const variant = getProductVariant(product);
    if (!variant || !variant.id) return '';

    const productTitle = escapeHtml(product.title);
    const productUrl = escapeHtml(normalizeProductUrl(product));
    const productImage = product.featured_image || product.image || (Array.isArray(product.images) ? product.images[0] : '');
    const price = Number(variant.price || product.price || 0);
    const compareAt = Number(variant.compare_at_price || product.compare_at_price || 0);
    const imageMarkup = productImage
      ? `<img src="${escapeHtml(productImage)}" alt="${productTitle}" class="nv-cart-drawer__upsell-image" loading="lazy">`
      : `<div class="nv-cart-drawer__upsell-image nv-cart-drawer__upsell-image--placeholder"></div>`;
    const compareMarkup = compareAt > price ? `<s>${formatMoney(compareAt)}</s>` : '';
    const ratingMarkup = renderRatingSummary(product, 'nv-cart-drawer__upsell-rating');

    return `
      <article class="nv-cart-drawer__upsell" data-upsell-product-id="${product.id}">
        <a href="${productUrl}" class="nv-cart-drawer__upsell-media" aria-label="${productTitle}">
          ${imageMarkup}
        </a>
        <div class="nv-cart-drawer__upsell-info">
          <a href="${productUrl}">${productTitle}</a>
          <div class="nv-cart-drawer__upsell-price">
            ${compareMarkup}
            <span>${formatMoney(price)}</span>
          </div>
          ${ratingMarkup}
        </div>
        <button
          type="button"
          class="nv-cart-drawer__upsell-add"
          data-nv-drawer-upsell-add
          data-variant-id="${variant.id}"
          ${variant.available === false ? 'disabled aria-disabled="true"' : ''}
        >
          Add to Cart
        </button>
      </article>
    `;
  };

  const refreshRecommendations = (cart) => {
    if (!upsellTrack || !cart.items || !cart.items.length) return Promise.resolve();

    const firstProductId = cart.items[0] && cart.items[0].product_id;
    if (!firstProductId || String(firstProductId) === String(lastRecommendationsProductId)) return Promise.resolve();
    lastRecommendationsProductId = firstProductId;

    const url = new URL(productRecommendationsUrl, window.location.origin);
    url.searchParams.set('product_id', firstProductId);
    url.searchParams.set('limit', '3');
    url.searchParams.set('intent', 'related');

    return fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load recommendations');
        return response.json();
      })
      .then((data) => {
        const cartProductIds = new Set((cart.items || []).map((item) => String(item.product_id)));
        const products = (data.products || [])
          .filter((product) => product && !cartProductIds.has(String(product.id)))
          .slice(0, 3);
        const markup = products.map(renderUpsellCard).filter(Boolean).join('');
        if (markup) {
          upsellTrack.innerHTML = markup;
        }
      })
      .catch(() => {});
  };

  const updateUpsells = (cart) => {
    const upsellSection = drawerShell.querySelector('[data-nv-cart-upsells]');
    if (!upsellSection) return;

    if (!cart.items || !cart.items.length) {
      upsellSection.hidden = true;
      return;
    }

    const cartProductIds = new Set((cart.items || []).map((item) => String(item.product_id)));
    let visibleCount = 0;
    drawerShell.querySelectorAll('[data-upsell-product-id]').forEach((card) => {
      const isInCart = cartProductIds.has(card.getAttribute('data-upsell-product-id'));
      card.hidden = isInCart;
      if (!isInCart) visibleCount += 1;
    });
    upsellSection.hidden = visibleCount === 0;
    startUpsellAuto();
  };

  const getVisibleUpsellCards = () => {
    if (!upsellTrack) return [];
    return Array.from(upsellTrack.querySelectorAll('[data-upsell-product-id]')).filter((card) => !card.hidden);
  };

  const scrollUpsells = (direction = 1) => {
    const cards = getVisibleUpsellCards();
    if (!upsellTrack || cards.length < 2) return;

    const trackLeft = upsellTrack.getBoundingClientRect().left;
    const currentIndex = cards.reduce((closestIndex, card, index) => {
      const closest = cards[closestIndex];
      const cardLeft = card.getBoundingClientRect().left - trackLeft + upsellTrack.scrollLeft;
      const closestLeft = closest.getBoundingClientRect().left - trackLeft + upsellTrack.scrollLeft;
      return Math.abs(cardLeft - upsellTrack.scrollLeft) < Math.abs(closestLeft - upsellTrack.scrollLeft)
        ? index
        : closestIndex;
    }, 0);
    const nextIndex = (currentIndex + direction + cards.length) % cards.length;
    const nextLeft = cards[nextIndex].getBoundingClientRect().left - trackLeft + upsellTrack.scrollLeft;
    upsellTrack.scrollTo({ left: nextLeft, behavior: 'smooth' });
  };

  const handleUpsellNavClick = (direction) => {
    pauseUpsellAuto();
    scrollUpsells(direction);
  };

  const stopUpsellAuto = () => {
    if (upsellAutoTimer) window.clearInterval(upsellAutoTimer);
    if (upsellResumeTimer) window.clearTimeout(upsellResumeTimer);
    upsellAutoTimer = null;
    upsellResumeTimer = null;
  };

  const startUpsellAuto = () => {
    stopUpsellAuto();
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!upsellTrack || reduceMotion || getVisibleUpsellCards().length < 2) return;
    upsellAutoTimer = window.setInterval(() => {
      if (!drawerShell.classList.contains('is-open')) return;
      scrollUpsells(1);
    }, 5200);
  };

  const pauseUpsellAuto = () => {
    stopUpsellAuto();
    upsellResumeTimer = window.setTimeout(startUpsellAuto, 9000);
  };

  const renderCart = (cart) => {
    const itemCount = Number(cart.item_count) || 0;
    const total = formatMoney(cart.total_price);
    const compareTotal = getCartCompareTotal(cart);
    const showCompareTotal = compareTotal > Number(cart.total_price || 0);

    cartCountEls.forEach((element) => {
      element.textContent = itemCount;
    });
    cartSubtotalEls.forEach((element) => {
      element.textContent = total;
    });
    cartCompareTotalEls.forEach((element) => {
      if (showCompareTotal) {
        element.textContent = formatMoney(compareTotal);
        element.hidden = false;
      } else {
        element.textContent = '';
        element.hidden = true;
      }
    });
    updateHeaderBadges(itemCount);
    updateFreeShipping(cart);
    renderDiscounts(cart);
    updateUpsells(cart);
    refreshRecommendations(cart).then(() => updateUpsells(cart));

    const checkoutButton = cartFooter && cartFooter.querySelector('.nv-cart-drawer__checkout');
    if (checkoutButton) {
      checkoutButton.disabled = itemCount === 0;
      checkoutButton.setAttribute('aria-disabled', String(itemCount === 0));
    }

    if (!cartItems) return;
    if (itemCount === 0) {
      cartItems.innerHTML = `
        <div class="nv-cart-drawer__empty" data-nv-cart-empty>
          <h3>Your cart is empty</h3>
          <p>Choose a clinical wellness formula to start your NutraVora routine.</p>
          <a class="btn" href="${escapeHtml(cartUrl.replace(/\/cart$/, '/collections/all'))}">Continue shopping</a>
        </div>
      `;
      return;
    }

    cartItems.innerHTML = (cart.items || []).map(renderCartItem).join('');
  };

  const refreshDrawerLiquidFragments = () => fetch(cartUrl, { headers: { Accept: 'text/html' } })
    .then((response) => {
      if (!response.ok) throw new Error('Unable to refresh cart drawer');
      return response.text();
    })
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshDrawer = doc.querySelector('[data-nv-cart-drawer]');
      if (!freshDrawer) return;

      const freshItems = freshDrawer.querySelector('[data-nv-cart-items]');
      if (freshItems && cartItems) {
        cartItems.innerHTML = freshItems.innerHTML;
      }

      const freshActions = freshDrawer.querySelector('.nv-cart-drawer__actions');
      const currentActions = cartFooter && cartFooter.querySelector('.nv-cart-drawer__actions');
      if (freshActions && currentActions) {
        currentActions.outerHTML = freshActions.outerHTML;
      } else if (freshActions && cartFooter) {
        const actionAnchor = cartFooter.querySelector('.nv-cart-drawer__note') || cartFooter.querySelector('.nv-cart-drawer__subtotal');
        if (actionAnchor) {
          actionAnchor.insertAdjacentHTML('afterend', freshActions.outerHTML);
        } else {
          cartFooter.appendChild(freshActions.cloneNode(true));
        }
      } else if (!freshActions && currentActions) {
        currentActions.remove();
      }
    })
    .catch(() => {});

  const fetchCart = () => fetch(cartJsonUrl, { headers: { Accept: 'application/json' } }).then((response) => {
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  });

  const refreshCart = () => fetchCart().then((cart) => {
    renderCart(cart);
    return refreshDrawerLiquidFragments().then(() => cart);
  });

  const queueCartRequest = (requestFactory) => {
    cartRequest = cartRequest
      .catch(() => {})
      .then(requestFactory)
      .then((cart) => {
        renderCart(cart);
        return refreshDrawerLiquidFragments().then(() => cart);
      });
    return cartRequest;
  };

  const openDrawer = () => {
    lastFocusedElement = document.activeElement;
    drawerShell.classList.add('is-open');
    drawerShell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nv-cart-drawer-open');
    refreshCart().catch(() => {});
    window.setTimeout(() => {
      if (drawer) drawer.focus();
    }, 60);
  };

  const getCartDiscountAmount = (cart) => {
    if (!cart) return 0;
    let amount = Number(cart.total_discount) || 0;

    if (amount > 0) return amount;

    (cart.cart_level_discount_applications || []).forEach((discount) => {
      amount += Number(discount.total_allocated_amount) || 0;
    });

    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((discount) => {
        amount += Number(discount.amount) || 0;
      });
    });

    return amount;
  };

  const cartHasDiscountCode = (cart, code) => {
    if (!cart || !code) return false;
    const normalizedCode = String(code).trim().toLowerCase();
    const titleMatches = (title) => {
      const normalizedTitle = String(title || '').trim().toLowerCase();
      return normalizedTitle === normalizedCode || normalizedTitle.includes(normalizedCode);
    };

    if ((cart.cart_level_discount_applications || []).some((discount) => titleMatches(discount.title))) {
      return true;
    }

    return (cart.items || []).some((item) => (
      (item.line_level_discount_allocations || []).some((discount) => (
        discount.discount_application && titleMatches(discount.discount_application.title)
      ))
    ));
  };

  const setCouponMessage = (message, type = 'error') => {
    if (!couponSheet) return;
    const messageEl = couponSheet.querySelector('[data-nv-cart-coupon-message]');
    if (!messageEl) return;

    messageEl.classList.remove('is-error', 'is-success');

    if (!message) {
      messageEl.textContent = '';
      messageEl.hidden = true;
      return;
    }

    messageEl.textContent = message;
    messageEl.hidden = false;
    messageEl.classList.add(type === 'success' ? 'is-success' : 'is-error');
  };

  const applyCouponCode = async () => {
    if (!couponSheet) return;
    const input = couponSheet.querySelector('#NvCartDrawerDiscount');
    const applyButton = couponSheet.querySelector('[data-nv-cart-coupon-apply]');
    const code = input ? input.value.trim() : '';

    if (!code) {
      setCouponMessage('Enter a discount code.');
      if (input && typeof input.focus === 'function') input.focus({ preventScroll: true });
      return;
    }

    const originalButtonText = applyButton ? applyButton.textContent : '';
    if (applyButton) {
      applyButton.disabled = true;
      applyButton.classList.add('is-loading');
      applyButton.textContent = 'Checking';
    }

    try {
      const beforeCart = await fetchCart();
      const beforeDiscountAmount = getCartDiscountAmount(beforeCart);
      const discountUrl = new URL(`/discount/${encodeURIComponent(code)}`, window.location.origin);
      discountUrl.searchParams.set('redirect', cartJsonUrl);

      const response = await fetch(discountUrl.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      let nextCart = null;
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        nextCart = await response.json();
      }

      if (!nextCart || !nextCart.items) {
        nextCart = await fetchCart();
      }

      renderCart(nextCart);
      await refreshDrawerLiquidFragments();

      const afterDiscountAmount = getCartDiscountAmount(nextCart);
      const discountApplied = cartHasDiscountCode(nextCart, code) || afterDiscountAmount > beforeDiscountAmount;

      if (discountApplied) {
        setCouponMessage('Discount applied to your cart.', 'success');
        window.setTimeout(() => {
          closeCouponSheet();
        }, 700);
      } else {
        setCouponMessage('The discount code cannot be applied to your cart.');
      }
    } catch (error) {
      setCouponMessage('The discount code cannot be applied to your cart.');
    } finally {
      if (applyButton) {
        applyButton.disabled = false;
        applyButton.classList.remove('is-loading');
        applyButton.textContent = originalButtonText || 'Apply';
      }
    }
  };

  const openCouponSheet = () => {
    if (!couponSheet) return;
    lastCouponFocusedElement = document.activeElement;
    setCouponMessage('');
    couponSheet.hidden = false;
    couponSheet.setAttribute('aria-hidden', 'false');
    if (couponOpenButton) couponOpenButton.setAttribute('aria-expanded', 'true');
    if (couponDisclosure) couponDisclosure.classList.add('is-coupon-open');

    window.requestAnimationFrame(() => {
      couponSheet.classList.add('is-open');
      const input = couponSheet.querySelector('#NvCartDrawerDiscount');
      if (input && typeof input.focus === 'function') input.focus({ preventScroll: true });
    });
  };

  const closeCouponSheet = ({ restoreFocus = true } = {}) => {
    if (!couponSheet || couponSheet.hidden) return;
    couponSheet.classList.remove('is-open');
    couponSheet.setAttribute('aria-hidden', 'true');
    if (couponOpenButton) couponOpenButton.setAttribute('aria-expanded', 'false');
    if (couponDisclosure) couponDisclosure.classList.remove('is-coupon-open');

    window.setTimeout(() => {
      if (couponSheet.classList.contains('is-open')) return;
      couponSheet.hidden = true;
    }, 240);

    if (restoreFocus && lastCouponFocusedElement && typeof lastCouponFocusedElement.focus === 'function') {
      lastCouponFocusedElement.focus({ preventScroll: true });
    }
  };

  const closeDrawer = () => {
    closeCouponSheet({ restoreFocus: false });
    drawerShell.classList.remove('is-open');
    drawerShell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nv-cart-drawer-open');
    stopUpsellAuto();
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', closeDrawer);
  });

  if (couponOpenButton) {
    couponOpenButton.addEventListener('click', (event) => {
      event.preventDefault();
      openCouponSheet();
    });
  }

  if (couponSheet) {
    couponSheet.addEventListener('click', (event) => {
      const applyButton = event.target.closest('[data-nv-cart-coupon-apply]');
      if (applyButton) {
        event.preventDefault();
        applyCouponCode();
        return;
      }

      const closeButton = event.target.closest('[data-nv-cart-coupon-close]');
      if (!closeButton) return;
      event.preventDefault();
      closeCouponSheet();
    });

    couponSheet.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !event.target.matches('#NvCartDrawerDiscount')) return;
      event.preventDefault();
      applyCouponCode();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (!drawerShell.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      if (couponSheet && couponSheet.classList.contains('is-open')) {
        closeCouponSheet();
        return;
      }
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab' || !drawer) return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (cartBody) {
    cartBody.addEventListener('click', (event) => {
      const upsellPrev = event.target.closest('[data-nv-cart-upsell-prev]');
      const upsellNext = event.target.closest('[data-nv-cart-upsell-next]');
      const qtyButton = event.target.closest('[data-cart-qty-change]');
      const removeButton = event.target.closest('[data-cart-remove]');
      const upsellButton = event.target.closest('[data-nv-drawer-upsell-add]');

      if (upsellPrev || upsellNext) {
        event.preventDefault();
        pauseUpsellAuto();
        scrollUpsells(upsellNext ? 1 : -1);
        return;
      }

      if (qtyButton) {
        const line = Number(qtyButton.getAttribute('data-line'));
        const delta = Number(qtyButton.getAttribute('data-cart-qty-change')) || 0;
        const input = cartBody.querySelector(`[data-cart-qty-input][data-line="${line}"]`);
        const nextQuantity = Math.max(0, (Number(input && input.value) || 0) + delta);
        if (input) input.value = nextQuantity;
        queueCartRequest(() => fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity: nextQuantity })
        }).then((response) => response.json()));
      }

      if (removeButton) {
        const line = Number(removeButton.getAttribute('data-line'));
        queueCartRequest(() => fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        }).then((response) => response.json()));
      }

      if (upsellButton) {
        const id = upsellButton.getAttribute('data-variant-id');
        upsellButton.disabled = true;
        queueCartRequest(() => fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        }).then((response) => {
          if (!response.ok) throw new Error('Unable to add upsell');
          return fetchCart();
        })).finally(() => {
          upsellButton.disabled = false;
        });
      }
    });

    cartBody.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-qty-input]');
      if (!input) return;

      const line = Number(input.getAttribute('data-line'));
      const quantity = Math.max(0, Number(input.value) || 0);
      input.value = quantity;
      queueCartRequest(() => fetch(cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      }).then((response) => response.json()));
    });
  }

  if (upsellCarousel) {
    const prevButton = upsellCarousel.querySelector('[data-nv-cart-upsell-prev]');
    const nextButton = upsellCarousel.querySelector('[data-nv-cart-upsell-next]');

    if (prevButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        handleUpsellNavClick(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        handleUpsellNavClick(1);
      });
    }

    ['pointerdown', 'wheel', 'focusin'].forEach((eventName) => {
      upsellCarousel.addEventListener(eventName, pauseUpsellAuto, { passive: true });
    });
    upsellCarousel.addEventListener('mouseenter', stopUpsellAuto);
    upsellCarousel.addEventListener('mouseleave', startUpsellAuto);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    if (form.closest('[data-nv-cart-drawer]')) return;

    event.preventDefault();
    const submitter = event.submitter;
    if (submitter) submitter.setAttribute('aria-busy', 'true');

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then((response) => {
      if (!response.ok) throw new Error('Unable to add item');
      openDrawer();
      return refreshCart();
    }).catch(() => {
      HTMLFormElement.prototype.submit.call(form);
    }).finally(() => {
      if (submitter) submitter.removeAttribute('aria-busy');
    });
  });

    cartDrawerApi = {
      open: openDrawer,
      refresh: refreshCart
    };

    return cartDrawerApi;
  };

  const initializeCartFromIntent = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !target.closest('[data-nv-cart-drawer-open], form[action*="/cart/add"]')) return;
    initializeCartDrawer();
  };

  document.addEventListener('pointerdown', initializeCartFromIntent, { capture: true, passive: true });
  document.addEventListener('focusin', initializeCartFromIntent, true);
  document.addEventListener('click', initializeCartFromIntent, true);
  document.addEventListener('submit', initializeCartFromIntent, true);

  const handleCartRefresh = () => {
    const api = initializeCartDrawer();
    if (api) api.open();
  };

  document.addEventListener('cart:refresh', handleCartRefresh);
  window.addEventListener('cart:refresh', handleCartRefresh);
});
